module.exports = __webpack_public_path__ + "static/media/23@3x.fe2e5701.png";